
// export default WarehouseRoutes;
import { action_options, app_modules } from "helpers/apps_modules_list";
// import WareHouseStockSummaryViewDetails from "pages/Inventory/Inventory/WareHouseStockSummary/WareHouseStockSummaryViewDetails";
import DispatchForm from "pages/Warehouse/Dispatch/Form/DispatchForm";
import EditDispatchForm from "pages/Warehouse/Dispatch/Form/EditDispatchForm";
import WarehouseDispatch from "pages/Warehouse/Dispatch/List/Dispatch";
import DispatchViewDetails from "pages/Warehouse/Dispatch/View/ViewDispatch";
import ViewDispatchDetailsPackingDone from "pages/Warehouse/Dispatch/View/ViewDispatchDetailsPackingd";
import WarehouseCreateGRN from "pages/Warehouse/ItemInward/Form/Create/CreateGRN";
import WarehouseEditGRN from "pages/Warehouse/ItemInward/Form/Edit/EditGRN";
import ProcessReturnedAccessories from "pages/Warehouse/ItemInward/Form/ReturnedAccessories/ProcessReturnedAccessories";
import EditReturnedAccessoriesGRN from "pages/Warehouse/ItemInward/Form/ReturnedAccessories/EditReturnedAccessoriesGRN";
import ViewReturnedAccessoriesGRN from "pages/Warehouse/ItemInward/Form/ReturnedAccessories/ViewReturnedAccessoriesGRN";
import ViewReturnedAccessoriesPending from "pages/Warehouse/ItemInward/Form/ReturnedAccessories/ViewReturnedAccessoriesPending";
import WarehouseItemInward from "pages/Warehouse/ItemInward/List";
import GRNItemDetails from "pages/Warehouse/ItemInward/View/GRNItemDetails";

import GRNViewDetails from "pages/Warehouse/ItemInward/View/GRNViewDetails";
import CreateWatehouseAllocationPacking from "pages/Warehouse/Packing/Form/AllocationCreatePacking";
import CreateWatehousePackingNew from "pages/Warehouse/Packing/Form/CreatePackingNew";
import CreateWatehouseItemRequestPacking from "pages/Warehouse/Packing/Form/ItemRequestCreatePacking";
import WarehousePacking from "pages/Warehouse/Packing/Listing";
import WarehousePackingDoneViewDetails from "pages/Warehouse/Packing/WarehousePackingDoneViewDetails";
import WarehousePackingDoneEditDetails from "pages/Warehouse/Packing/Edit/EditPacking";
import WarehousePackingViewDetails from "pages/Warehouse/Packing/WarehousePackingViewDetails";
import ProjectWarehouse from "pages/Warehouse/Project Warehouse";
import CreateStockTransferForm from "pages/Warehouse/Project Warehouse/CreateStockTransferForm";
import Damage from "pages/Warehouse/Project Warehouse/Damage";
import InStockItemsDetailsListings from "pages/Warehouse/Project Warehouse/InStockItemsDetailsListings";
import DamageItemsDetailsListings from "pages/Warehouse/Project Warehouse/ItemsDetailsListings";
import TransferRequest from "pages/Warehouse/Project Warehouse/TransferRequest";
import ViewTransferRequest from "pages/Warehouse/Project Warehouse/ViewTransferRequest";
import WarehouseStockOverview from "pages/Warehouse/StockOverview/List";
import InstockItemDetails from "pages/Warehouse/StockOverview/View/InstockItemDetails";
// import DamagedDetails from "pages/Warehouse/StockOverview/View/DamagedDetails";

const WarehouseRoutes: any = [
  // {
  //   path: "/warehouse-oandm-warehouse",
  //   name: "Warehouse Item Inward",
  //   component: <OandMwarehouse  />,
  //   permissions: {app_name:app_modules.warehouse.app_name,module_name: app_modules.warehouse.modules.oandm_warehouse,action: action_options?.view,}
  // },
  {
    path: "/warehouse-item-inward",
    name: "Warehouse Item Inward",
    component: <WarehouseItemInward />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.view, }
  },
  {
    path: "/warehouse-item-inward-create-grn/:po_id/:warehouse_id",
    name: "Warehouse Item Inward Create GRN Form",
    component: <WarehouseCreateGRN />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.create, }
  },
  {
    path: "/warehouse-item-inward-edit-grn/:po_id/:inventory_id",
    name: "Warehouse Item Inward Edit GRN Form",
    component: <WarehouseEditGRN />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.create, }
  },

  {
    path: "/warehouse/item-inward/returned-accessories/:challan_id/process",
    name: "Process Returned Accessories",
    component: <ProcessReturnedAccessories />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.view, }
  },
  {
    path: "/warehouse/item-inward/returned-accessories/grn/:inward_id/edit",
    name: "Edit Returned Accessories GRN",
    component: <EditReturnedAccessoriesGRN />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.view, }
  },
  {
    path: "/warehouse/item-inward/returned-accessories/:challan_id/view",
    name: "View Pending Returned Accessories",
    component: <ViewReturnedAccessoriesPending />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.view, }
  },
  {
    path: "/warehouse/item-inward/returned-accessories/grn/:inward_id",
    name: "View Returned Accessories GRN",
    component: <ViewReturnedAccessoriesGRN />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.view, }
  },

  {
    path: "/warehouse/stock-overview",
    name: "Warehouse Project Warehouse",
    component: <WarehouseStockOverview />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.stock_overview, action: action_options?.view, }
  },
  // {
  //   path: "/warehouse/stock-overview/:tab",
  //   name: "Warehouse Project Warehouse Tab",
  //   component: <ProjectWarehouse />,
  //   permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.project_warehouse, action: action_options?.view, }
  // },
  {
    path: "/warehouse-transfer-request",
    name: "Warehouse Transfer Request",
    component: <TransferRequest />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.stock_overview, action: action_options?.view, }
  },
  {
    path: "/warehouse-damage",
    name: "Warehouse Damage",
    component: <Damage />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.stock_overview, action: action_options?.view, }
  },
  {
    path: "/warehouse-damage-items-listings/:id",
    name: "",
    component: <DamageItemsDetailsListings />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.stock_overview, action: action_options?.view, }
  },
  {
    path: "/warehouse-in-stock-items-listings/:id",
    name: "In Stock Items Details",
    component: <InStockItemsDetailsListings />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.stock_overview, action: action_options?.view, }
  },
  {
    path: `/view-transfer-req-details/:id`,
    name: "view transfer req details",
    component: <ViewTransferRequest />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.stock_overview, action: action_options?.view, }
  },
  {
    path: "/create-stock-transfer",
    name: "Create Stock Transfer",
    component: <CreateStockTransferForm />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.stock_overview, action: action_options?.create, }
  },

  // Dispact Routes
  {
    path: "/warehouse-dispatch",
    name: "Warehouse Dispatch Listing",
    component: <WarehouseDispatch />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.dispatch, action: action_options?.view, }
  },
  {
    path: "/add-warehouse-dispatch",
    name: "add warehouse dispatch",
    component: <DispatchForm />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.dispatch, action: action_options?.create, }
  },
  {
    path: "/edit-warehouse-dispatch/:dispatch_id",
    name: "edit warehouse dispatch",
    component: <EditDispatchForm />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.dispatch, action: action_options?.create, }
  },
  {
    path: "/dispatch-view-details/:dispatch_id",
    name: "View Dispatch",
    component: <DispatchViewDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.dispatch, action: action_options?.view, }
  },

  // Item Inword Routes

  {
    path: "/grn-view-details/:inventory_id",
    name: "Warehouse Item Inward GRN View details",
    component: <GRNViewDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.view, }
  },
  {
    path: "/grn-items-view-details/:inventory_id/:product_id",
    name: "GRN View details",
    component: <GRNItemDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.item_inward, action: action_options?.view, }
  },
  {
    path: "/warehouse-stock-overview-instock-item-details/:warehouse_id/:product_id",
    name: "In Stock Item Details",
    component: <InstockItemDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.stock_overview, action: action_options?.view, }
  },
  // {
  //   path: "/warehouse-stock-overview-damaged-item-details/:inventory_id/:product_id",
  //   name: "Damaged Item Details",
  //   component: <DamagedDetails />,
  //   permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.project_warehouse, action: action_options?.view, }
  // },

  // //  Allocation
  // {
  //   path: "/warehouse-allocation", component: <AllocationsWarehosue />,
  //   permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.allocation, action: action_options?.view, }
  // },
  // {
  //   path: "/warehouse-allocation-view",
  //   component: <WarehouseAllocationViewDetails />,
  //   permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.allocation, action: action_options?.view, }
  // },

  // Packing
  {
    path: "/warehouse-packing",
    name: "WarehousePacking",
    component: <WarehousePacking />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.view, }
  },
  {
    path: "/warehouse-create-packing/:id",
    name: "WarehouseCreatePacking",
    component: <CreateWatehousePackingNew />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.create, }
  },
  {
    path: "/warehouse-packing-view-details/:id",
    name: "WarehousePackingViewDetails",
    component: <WarehousePackingViewDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.view, }
  },
  {
    path: "/warehouse-allocation-create-packing/:id",
    name: "WarehouseCreatePacking",
    component: <CreateWatehouseAllocationPacking />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.create, }
  },
  {
    path: "/warehouse-allocation-packing-view-details/:id",
    name: "WarehousePackingViewDetails",
    component: <WarehousePackingViewDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.view, }
  },
  {
    path: "/warehouse-item-request-create-packing/:id",
    name: "WarehouseCreatePacking",
    component: <CreateWatehouseItemRequestPacking />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.create, }

  },
  {
    path: "/warehouse-item-request-packing-view-details/:id",
    name: "WarehousePackingViewDetails",
    component: <WarehousePackingViewDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.view, }
  },
  // {
  //   path: "/warehouse-packing-done",
  //   name: "WarehousePackingDone",
  //   component: <WarehousePacking />,
  //   permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.view, }
  // },
  {
    path: "/warehouse-packing-done-view-details/:id",
    name: "WarehousePackingDoneViewDetails",
    component: <WarehousePackingDoneViewDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.view, }
  },
    {
    path: "/warehouse-packing-done-edit-details/:id",
    name: "WarehousePackingDoneEditwDetails",
    component: <WarehousePackingDoneEditDetails />,
    permissions: { app_name: app_modules.warehouse.app_name, module_name: app_modules.warehouse.modules.packing, action: action_options?.view, }
  },
  // {
  //   path: "/warehouse-item-inward-create-grn-add-stock/:itemId",
  //   name: "Warehouse Item Inward Create GRN Form Add Stock",
  //   component: <ItemInwardAddStock />,
  // },
];


export default WarehouseRoutes;
